export default __webpack_public_path__ + "static/media/go.e6524296.png";